import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  Form,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { ToastService } from 'src/app/services/toast.service';
import {
  ContentStoreService,
  ContentStoreState,
} from 'src/app/services/marketplace/content-store.service';
import {
  elevationRanges,
  ip,
  ruralLocationRanges,
  shopsRanges,
  urbanLocationRanges,
  biomeRanges,
  geozoneRanges,
} from 'src/app/constant/constant';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { CityWebDataService } from 'src/app/services/city-web-data.service';
import { AiGenerationComponent } from '../../player/modals/ai-generation/ai-generation.component';
import { min } from 'd3';
import moment from 'moment';
import {
  CustomFileUploadValidators,
  trimmedMinLengthValidator,
} from 'src/app/custom-validators/customvalidators';
import { notZeroValidator } from 'src/app/custom-validators/not-zero.validator';
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  map,
  Observable,
  of,
  Subscription,
} from 'rxjs';
import { ReportingModalComponent } from 'src/app/modal/reporting-modal/reporting-modal.component';
import { SavingLoaderModalComponent } from 'src/app/modal/saving-loader-modal/saving-loader-modal.component';
import { MapDataService } from 'src/app/services/map-data.service';
import { CanComponentDeactivateContent } from './guards/unsaved-content.guard';
import { digitalReadinessLevels } from './static/digital-readiness.constant';
import { ContentCheckBoxObject } from 'src/app/models/content-creator.model';
import { vttCompatibleLevels } from './static/vtt-compatible.constant';
import { languageLevels } from './static/language.constant';
import { contentWarnings } from './static/content-warning.constant';
import { licenseTypes } from './static/license-type.constant';
import { aiTextTools } from './static/ai-text-tools.constant';
import { aiImageTools } from './static/ai-image-tools.constant';
import {
  processGenreGroups,
  getGenreItemsByCategory,
  findCategoryByGenre,
  GenreGroup,
  GenreItem,
} from './utils/genre-category.helper';
import {
  ContentAttachPayload,
  ContentData,
  ContentFile,
  MapFile,
  Pin,
  RatingResponse,
} from './models/content.model';
import { HttpClient } from '@angular/common/http';
import { ContentImageUploadModalComponent } from 'src/app/pages/shared/content-image-upload-modal/content-image-upload-modal.component';
import { environment } from 'src/environments/environment';
import { StoreLinkService } from 'src/app/services/marketplace/store-link.service';

@Component({
    selector: 'app-add-content',
    templateUrl: './add-content.component.html',
    styleUrls: ['./add-content.component.scss'],
    standalone: false
})
export class AddContentComponent
  implements OnInit, OnDestroy, OnChanges, CanComponentDeactivateContent
{
  creatorDetailsForm: FormGroup;
  digitalReadinessLevels = digitalReadinessLevels;
  vttCompatibleLevels = vttCompatibleLevels;
  languageLevels = languageLevels;
  contentWarnings = contentWarnings;
  licenseTypes = licenseTypes;
  aiTextTools = aiTextTools;
  aiImageTools = aiImageTools;
  selectedGameImage: any;
  contentId;
  params!: string;
  contentData!: ContentData;
  coordsRecieve: any;
  gameTypeData: any = null;
  isModalOpen: boolean = false;
  gameSystemListdata: any = null;
  uploadContainerHeight: string = '400px';
  contentImgArr: any[] = [];
  userId: any;
  coords: any;
  contentDataImageArr: any[] = [];
  isCreatorImageTouched: boolean = false;
  titleDynamicVal: string = '';
  isEdit: boolean = false;
  ip: any = ip;
  mapCode: any;
  backWordNavigateUrl: string;
  cityCode: any;
  @ViewChild('map', { read: ElementRef, static: true }) mapElement: ElementRef;
  allContentData: any[] = [];
  isClassAdded = false;
  private pendingCreateType: string | null = null;
  productlist: any;
  contentPotrait: any;
  elevationRanges = elevationRanges;
  ruralLocationRanges = ruralLocationRanges;
  shopsRanges = shopsRanges;
  urbanLocationRanges = urbanLocationRanges;
  biomeRanges = biomeRanges;
  geozoneRanges = geozoneRanges;
  errorMessage: string = '';
  activePath: string;
  currentUserSubscription: Subscription | null = null;
  files: File[] = [];
  minFilesRequired: number = 1; // Set your desired minimum number of files
  maxFilesLimit: number = 3;
  characters: any[] = [];
  maxTotalFileSize = 25 * 1024 * 1024; // 25 MB in bytes   // Set your desired maximum number of files
  allowedMimeTypes: string[] = [
    // Documents
    'application/pdf',
    'application/msword', // .doc
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'application/vnd.oasis.opendocument.text', // .odt
    'application/rtf', // .rtf
    'text/plain', // .txt
  ];
  allowedMimeTypesForMapFiles: string[] = [
    // Images
    'image/png',
    'image/jpeg', // .jpg, .jpeg
    'image/webp',
    'application/pdf', // .pdf
    'image/vnd.adobe.photoshop', // .psd
    'image/svg+xml', // .svg
  ];
  maxIndividualFileSize = 10 * 1024 * 1024;
  gamePotraitFile: File | null = null;
  downloading: boolean = false;
  isSaving: boolean = false;
  rawCoordinates: string | null = null;
  isOnlyRestore: string | null = '';
  isEditable: string | boolean = true;
  moduleRating: number = 0;
  backing: boolean = false;
  gameGenereList: GenreGroup[];
  selectedGameGenreCategoryItems: GenreItem[] = [];
  selectedGameGenreCategory: string | null = null;
  mapGenreList = [
    {
      label: 'Science Fiction & Science Fantasy (Traveller, etc)',
      value: 'Starfinder',
    },
    { label: 'Fantasy (Dungeons & Dragons, etc)', value: 'Pathfinder' },
    {
      label: 'Modern & Horror (Call of Cthulhu, etc)',
      value: 'Call of Cthulhu',
    },
  ];
  userContentRating: number = 0;
  genreListSortOrder: any[] = [
    'Fantasy (Dungeons & Dragons, etc)',
    'Modern & Horror (Call of Cthulhu, etc)',
    'Science Fiction & Science Fantasy (Traveller, etc)',
  ];
  userContentReview: string = '';
  see_on_map_coordinates: string = '';
  private productListLoaded = new BehaviorSubject<boolean>(false);
  private formReady$ = new BehaviorSubject<boolean>(false);

  constructor(
    private mapService: MapService,
    private elementRef: ElementRef,
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private toastService: ToastService,
    private modalService: NgbModal,
    private currentUserService: CurrentUserService,
    private router: Router,
    private activeModal: NgbActiveModal,
    private coordinateService: CoordinatesService,
    private cityDataService: CityWebDataService,
    private activatedRoute: ActivatedRoute,
    private mapDataService: MapDataService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private contentStoreService: ContentStoreService,
    private storeLinks: StoreLinkService,
  ) {
    this.isClassAdded = true;
  }

  /** "Sell in store" state for the item being edited; null until loaded / not applicable. */
  storeState: ContentStoreState | null = null;
  storeBusy = false;

  private loadStoreState(): void {
    if (!this.contentData?.id || !this.isEditable) return;
    this.contentStoreService.get(this.contentData.id).subscribe({
      next: (state) => {
        this.storeState = state;
        this.cdr.detectChanges();
      },
      // Not the creator, or the marketplace API unavailable: no Store panel.
      error: () => {
        this.storeState = null;
        this.cdr.detectChanges();
      },
    });
  }

  /** Start/stop selling this item, at the PRICE field's current value. */
  setSelling(sell: boolean): void {
    if (!this.contentData?.id || this.storeBusy) return;
    this.storeBusy = true;
    const price = this.creatorDetailsForm.get('price')?.value;
    this.contentStoreService.set(this.contentData.id, sell, sell ? price : undefined).subscribe({
      next: (state) => {
        this.storeState = state;
        this.storeBusy = false;
        const messages: Record<ContentStoreState['state'], string> = {
          in_store: 'Your content is now in the store.',
          draft: 'Saved — it goes live once your seller setup is finished.',
          hidden: 'Removed from the store. Past buyers keep access.',
          private: 'Your content is private.',
        };
        this.toastService.showSuccess(messages[state.state], 'success');
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.storeBusy = false;
        const detail = err?.error?.price?.[0] || err?.error?.[0] || err?.error?.detail;
        this.toastService.showNote(detail || 'Could not update the store listing.', 'danger');
        this.cdr.detectChanges();
      },
    });
  }

  getForm() {
    return this.creatorDetailsForm;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['params'] && changes['params'].currentValue) {
      this.formPatchValue();
    }
  }
  ngOnDestroy(): void {
    this.currentUserSubscription?.unsubscribe();
    this.mapPreviewUrls.forEach((url) => URL.revokeObjectURL(url));
    this.mapPreviewUrls.clear();
  }

  getCharacters(userId) {
    this.dataService.Getcharacterdetail(userId).subscribe(
      (res: any) => {
        if (!res || !res.character_details) {
          console.error('Invalid response from Getcharacterdetail');
          return;
        }

        if (res.character_details.length === 0) {
          this.characters = [
            { id: 'CREATE_NEW', display_name: 'Create New Character' },
          ];
          return;
        }
        const data = res.character_details || [];

        let characters = data;

        if (this.mapCode) {
          characters = characters.filter((c) => c.map_code === this.mapCode);
        }

        const updatedCharacters = characters.map((c) => ({
          ...c,
          display_name: `${c.nickname} - ${c.race} Level ${c.primary_class_level} ${c.sex} ${c.primary_class}`,
        }));

        // Add "Create New" option at the beginning
        this.characters = [
          { id: 'CREATE_NEW', display_name: 'Create New Character' },
          ...updatedCharacters,
        ];
        this.cdr.detectChanges();
      },
      (error) => {
        this.toastService.showSuccess('Something went wrong. Please try again.', 'Error');
      
          this.cdr.detectChanges();},
    );
  }

  initForm() {
    if (this.creatorDetailsForm) return; // prevent rebuilding
    console.log(this.contentData, 'this is content data');
    this.currentUserSubscription =
      this.currentUserService.currentUser.subscribe((data) => {
        if (data) {
          this.userId = Number(data.id);
          this.getCharacters(this.userId);
          const date = moment().format('MM/DD/YYYY');
          this.creatorDetailsForm = this.formBuilder.group({
            game_system: ['', Validators.required],
            game_genre: ['', Validators.required],
            type: ['', Validators.required],
            digital_readiness_level: [''],
            virtual_table_top: [''],
            languages: [['English (Default)']],
            content_rating: [''],
            license_type: ['Single Purchaser License (Standard Use License)'],
            citycode: [''],
            characters: [''],
            playtime: [
              0,
              [Validators.min(0), Validators.required, notZeroValidator],
            ],
            partyaverage: [
              0,
              [Validators.min(0), Validators.required, notZeroValidator],
            ],
            price: [0, [Validators.min(0)]],
            sold: [0, [Validators.min(0)]],
            gameimage: [''],
            contentimagearr: [[]],
            description: [
              '',
              [Validators.required, trimmedMinLengthValidator(100)],
            ],
            content_title: ['', Validators.required],
            party_min_size: [
              0,
              [Validators.min(0), Validators.required, notZeroValidator],
            ],
            party_max_size: [
              0,
              [
                Validators.min(0),
                Validators.required,
                Validators.max(8),
                notZeroValidator,
              ],
            ],
            recommended_party_avarage: [0, [Validators.min(0)]],
            cover_image: ['', Validators.required],
            ai_text_generator_used: [false],
            ai_text_tool_usage: [{ value: null, disabled: true }],
            ai_text_tool_usage_percentage: [
              { value: null, disabled: true },
              [Validators.min(0), Validators.max(100), Validators.required],
            ],
            ai_image_generator_used: [false],
            ai_image_tool_usage: [{ value: null, disabled: true }],
            ai_image_tool_usage_percentage: [
              { value: null, disabled: true },
              [Validators.min(0), Validators.max(100), Validators.required],
            ],
            creator: [
              { value: data.display_name, disabled: true },
              Validators.required,
            ],
            creator_visible_on_game: [false],
            creator_visible_on_map: [false],
            created_at: [
              { value: date, disabled: true },
              [Validators.required],
            ],
            adventure_writeup: this.formBuilder.array(
              [],
              [
                CustomFileUploadValidators.minFiles(this.minFilesRequired),
                CustomFileUploadValidators.maxFiles(this.maxFilesLimit),
                CustomFileUploadValidators.totalFileSize(this.maxTotalFileSize),
              ],
            ),
            map_files: this.formBuilder.array(
              [],
              [
                CustomFileUploadValidators.minFiles(this.minFilesRequired),
                CustomFileUploadValidators.maxFiles(this.maxFilesLimit),
                CustomFileUploadValidators.totalFileSize(this.maxTotalFileSize),
              ],
            ),
            elevation: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.elevationRanges.map(() => this.createRow()),
              ),
            }),
            geozone: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.geozoneRanges.map(() => this.createRow()),
              ),
            }),
            biome: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.biomeRanges.map(() => this.createRow()),
              ),
            }),
            ruralLocation: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.ruralLocationRanges.map(() => this.createRow()),
              ),
            }),

            urbanLocation: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.urbanLocationRanges.map(() => this.createRow()),
              ),
            }),

            shops: this.formBuilder.group({
              selectAll: [false],
              ranges: this.formBuilder.array(
                this.shopsRanges.map(() => this.createRow()),
              ),
            }),
          });
          this.applyPendingCreateType();
          this.formReady$.next(true);
        }
      
          this.cdr.detectChanges();});

    this.creatorDetailsForm
      .get('ai_text_generator_used')
      ?.valueChanges.subscribe((value) => {
        const control = this.creatorDetailsForm.get('ai_text_tool_usage');
        const percentageControl = this.creatorDetailsForm.get(
          'ai_text_tool_usage_percentage',
        );
        if (value) {
          control?.enable();
          percentageControl.enable();
        } else {
          control?.setValue('');
          percentageControl.setValue(null);
          control?.disable();
          percentageControl.disable();
        }
      
          this.cdr.detectChanges();});

    this.creatorDetailsForm
      .get('party_min_size')
      ?.valueChanges.subscribe((value) => {
        const maxValue = this.creatorDetailsForm.get('party_max_size')?.value;
        const minControl = this.creatorDetailsForm.get('party_min_size');
        if (value > maxValue) {
          minControl?.setErrors({ ...minControl.errors, invalidMin: true });
        } else {
          if (minControl?.hasError('invalidMin')) {
            delete minControl.errors?.['invalidMin'];
            if (Object.keys(minControl.errors || {}).length === 0) {
              minControl.setErrors(null);
            } else {
              minControl.updateValueAndValidity({ onlySelf: true });
            }
          }
        }
      
          this.cdr.detectChanges();});

    this.creatorDetailsForm
      .get('party_max_size')
      ?.valueChanges.subscribe((value) => {
        const minValue = this.creatorDetailsForm.get('party_min_size')?.value;
        const minControl = this.creatorDetailsForm.get('party_min_size');
        const maxControl = this.creatorDetailsForm.get('party_max_size');
        if (value < minValue) {
          maxControl?.setErrors({ ...maxControl.errors, invalidMax: true });
        } else {
          if (maxControl?.hasError('invalidMax')) {
            delete maxControl.errors?.['invalidMax'];
            if (Object.keys(maxControl.errors || {}).length === 0) {
              maxControl.setErrors(null);
            } else {
              maxControl.updateValueAndValidity({ onlySelf: true });
            }
          } else if (minControl?.hasError('invalidMin')) {
            delete minControl.errors?.['invalidMin'];
            if (Object.keys(minControl.errors || {}).length === 0) {
              minControl.setErrors(null);
            } else {
              minControl.updateValueAndValidity({ onlySelf: true });
            }
          }
        }
      
          this.cdr.detectChanges();});

    this.creatorDetailsForm
      .get('ai_image_generator_used')
      ?.valueChanges.subscribe((value) => {
        const control = this.creatorDetailsForm.get('ai_image_tool_usage');
        const percentageControl = this.creatorDetailsForm.get(
          'ai_image_tool_usage_percentage',
        );
        if (value) {
          control?.enable();
          percentageControl.enable();
        } else {
          control?.setValue('');
          percentageControl.setValue(null);
          control?.disable();
          percentageControl.disable();
        }
      
          this.cdr.detectChanges();});

    this.creatorDetailsForm.get('type')?.valueChanges.subscribe((value) => {
      if (value?.toLowerCase()?.includes('establishment')) {
        this.creatorDetailsForm.get('playtime')?.clearValidators();
        this.creatorDetailsForm
          .get('party_min_size')
          ?.removeValidators([Validators.required, notZeroValidator]);
        this.creatorDetailsForm
          .get('party_max_size')
          ?.removeValidators([Validators.required, notZeroValidator]);
        this.creatorDetailsForm.get('playtime')?.updateValueAndValidity();
        this.creatorDetailsForm.get('party_min_size')?.updateValueAndValidity();
        this.creatorDetailsForm.get('party_max_size')?.updateValueAndValidity();
        this.creatorDetailsForm
          .get('partyaverage')
          ?.removeValidators([Validators.required, notZeroValidator]);
        this.creatorDetailsForm.get('partyaverage')?.updateValueAndValidity();
      } else {
        this.creatorDetailsForm
          .get('playtime')
          ?.setValidators([
            Validators.min(0),
            Validators.required,
            notZeroValidator,
          ]);
        this.creatorDetailsForm
          .get('party_min_size')
          ?.addValidators([
            Validators.min(0),
            Validators.required,
            notZeroValidator,
          ]);
        this.creatorDetailsForm
          .get('party_max_size')
          ?.setValidators([
            Validators.min(0),
            Validators.required,
            Validators.max(8),
            notZeroValidator,
          ]);
        this.creatorDetailsForm.get('playtime')?.updateValueAndValidity();
        this.creatorDetailsForm.get('party_min_size')?.updateValueAndValidity();
        this.creatorDetailsForm.get('party_max_size')?.updateValueAndValidity();
        this.creatorDetailsForm
          .get('partyaverage')
          ?.addValidators([
            Validators.min(0),
            Validators.required,
            notZeroValidator,
          ]);
        this.creatorDetailsForm.get('partyaverage')?.updateValueAndValidity();
      }
    
          this.cdr.detectChanges();});

    // 👇 Extracted to a reusable method
    this.initMultiSelectLogic('elevation', this.elevationRangeRows);
    this.initMultiSelectLogic('geozone', this.geozoneRangeRows);
    this.initMultiSelectLogic('biome', this.biomeRangeRows);
    this.initMultiSelectLogic('ruralLocation', this.ruralLocationRows);
    this.initMultiSelectLogic('urbanLocation', this.urbanLocationRows);
    this.initMultiSelectLogic('shops', this.shopsRows);
    if (this.params === 'edit') {
      this.formPatchValue();
    }
  }

  private initMultiSelectLogic(
    groupName:
      | 'elevation'
      | 'geozone'
      | 'biome'
      | 'ruralLocation'
      | 'urbanLocation'
      | 'shops',
    rangeArray: FormArray,
  ) {
    // Handle selectAll toggle
    this.creatorDetailsForm
      .get(`${groupName}.selectAll`)
      ?.valueChanges.subscribe((selectAll: boolean) => {
        rangeArray.controls.forEach((control) => {
          control.get('selected')?.setValue(selectAll, { emitEvent: false });
        });
      
          this.cdr.detectChanges();});

    // Handle individual checkbox updates to toggle "selectAll"
    rangeArray.controls.forEach((control) => {
      control.get('selected')?.valueChanges.subscribe(() => {
        this.updateSelectAll(groupName);
      
          this.cdr.detectChanges();});
    });
  }

  saveChangesContent() {
    return this.handleFormSubmit();
  }

  formatKey(key) {
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  handleContentAttach(data: any): void {
    if ((this.mapCode || this.cityCode) && this.coords?.length >= 2) {
      // Content made in this app is pinned by its id (content_id); only old
      // WordPress items had a wp_product_id.
      if (!data.content_id && !data.wp_product_id) {
        console.warn('No content id in the response. Cannot attach content to map/city.');
        this.toastService.showSuccess(
          'Note: Content created but could not be automatically attached to the map.',
          'info',
        );
        return;
      }

      const attachPayload: ContentAttachPayload = {
        wp_product_id: data.wp_product_id,
        content_id: data.content_id ?? null,
        wp_user_id: this.userId,
        context: this.cityCode ? 'city' : 'map',
        map_id: this.mapCode || null,
        city_id: this.cityCode || null,
        latitude: this.coords[0],
        longitude: this.coords[1],
        label:
          this.creatorDetailsForm.get('content_title')?.value ||
          'Untitled Content',
      };

      this.dataService.contentAttach(attachPayload).subscribe({
        next: (resp) => {
          console.log('Content attached successfully:', resp);
        
          this.cdr.detectChanges();},
        error: (err) => {
          console.error('Error attaching content:', err);
          this.toastService.showSuccess(
            'Note: Content created but failed to attach to the map.',
            'info',
          );
        
          this.cdr.detectChanges();},
      });
    }
  }

  handleFormSubmit(): Observable<boolean> {
    const checkBoxObj: ContentCheckBoxObject = this.constructCheckBoxObject();

    if (this.creatorDetailsForm.invalid) {
      const invalid = this.getInvalidControls();
      const actualInvalidKey = invalid
        .map((key) => this.formatKey(key))
        .join(', ');
      this.errorMessage = actualInvalidKey;
      this.creatorDetailsForm.markAllAsTouched();
      return of(false);
    }

    const characters = this.creatorDetailsForm.get('characters')?.value;
    if (!Array.isArray(characters)) {
      this.creatorDetailsForm.get('characters')?.setValue([]);
      this.creatorDetailsForm.get('characters')?.updateValueAndValidity();
    }
    const obj = this.constructPayload(checkBoxObj);
    console.log(checkBoxObj, 'what is final payload ');

    if (this.creatorDetailsForm.valid && !this.contentData) {
      return this.dataService.createContent(obj, this.userId).pipe(
        map((data: any) => {
          if (data) {
            this.handleContentAttach(data);
            this.afterSuccessfulSubmission();
            this.toastService.showSuccess(
              'Content Added Successfully!',
              'success',
            );
            return true;
          }
          return false;
        }),
        catchError((error) => this.handleFormError(error)),
      );
    } else if (this.contentData && this.creatorDetailsForm.valid) {
      const obj = this.constructPayload(checkBoxObj);

      // obj.contentimagearr = obj.contentimagearr.filter((item) => !item.file);
      if (!this.isEdit) obj.gameimage = '';

      return this.dataService
        .updateContentById(this.contentData.id, obj, this.userId)
        .pipe(
          map((data: any) => {
            if (data) {
              this.afterSuccessfulSubmission();
              this.toastService.showSuccess(
                'Content Updated Successfully!',
                'success',
              );
              return true;
            }
            return false;
          }),
          catchError((error) => this.handleFormError(error)),
        );
    }

    return of(false);
  }

  createRow(): FormGroup {
    return this.formBuilder.group({
      selected: [false],
    });
  }

  get elevationRangeRows(): FormArray {
    return this.creatorDetailsForm.get('elevation.ranges') as FormArray;
  }

  get geozoneRangeRows(): FormArray {
    return this.creatorDetailsForm.get('geozone.ranges') as FormArray;
  }

  get biomeRangeRows(): FormArray {
    return this.creatorDetailsForm.get('biome.ranges') as FormArray;
  }

  get ruralLocationRows(): FormArray {
    return this.creatorDetailsForm.get('ruralLocation.ranges') as FormArray;
  }

  get urbanLocationRows(): FormArray {
    return this.creatorDetailsForm.get('urbanLocation.ranges') as FormArray;
  }

  get shopsRows(): FormArray {
    return this.creatorDetailsForm.get('shops.ranges') as FormArray;
  }

  get mapImageFilesArray(): FormArray {
    return this.creatorDetailsForm.get('adventure_writeup') as FormArray;
  }

  /** Local previews for newly picked map images; revoked in ngOnDestroy. */
  private mapPreviewUrls = new Map<File, string>();

  /**
   * What the Thumbnails section shows. The API generates thumbnails from the
   * map images itself, so: a local preview for each newly picked image, and
   * the server's thumbnail for map files the content already has.
   */
  get mapThumbnails(): { src: string; name: string }[] {
    const thumbs: { src: string; name: string }[] = [];
    for (const value of this.mapImageFilesArray?.value ?? []) {
      if (value instanceof File) {
        if (!value.type.startsWith('image/')) continue;
        let src = this.mapPreviewUrls.get(value);
        if (!src) {
          src = URL.createObjectURL(value);
          this.mapPreviewUrls.set(value, src);
        }
        thumbs.push({ src, name: value.name });
      } else if (value?.thumbnail) {
        thumbs.push({ src: value.thumbnail, name: value.name });
      }
    }
    return thumbs;
  }

  get mapFilesArray(): FormArray {
    return this.creatorDetailsForm.get('map_files') as FormArray;
  }

  formPatchValue() {
    if (!this.contentData.geozone) this.contentData.geozone = {};
    this.creatorDetailsForm.patchValue({
      game_system: this.contentData.gamesystem,
      game_genre: this.contentData.game_genre[0],
      type: Array.isArray(this.contentData.type)
        ? this.contentData.type[0]
        : this.contentData.type || '',
      digital_readiness_level: this.contentData.digital_readiness_level,
      virtual_table_top: this.contentData.virtual_table_top,
      languages: this.contentData.languages || ['English (Default)'],
      content_rating: this.contentData.content_warning,
      license_type: this.contentData.license_type,
      characters: this.contentData.characters,
      price: this.contentData.cost,
      cover_image: this.contentData.image_url || this.contentData.cover_image,
      sold: this.contentData.sold,
      party_min_size: this.contentData.party_min_size ?? 0,
      partyaverage: this.contentData.partyaverage,
      party_max_size: this.contentData.party_max_size ?? 0,
      playtime: this.contentData.playtime ?? 0,
      recommended_party: this.contentData.recommended_party,
      // module_version: this.contentData.module_version || this.contentData.moduleversion,
      gameimage: this.contentData.gameimage,
      contentimagearr: this.contentData.contentimagearr,
      description: this.contentData.description,
      ai_text_generator_used: this.contentData.ai_text_generator_used,
      ai_text_tool_usage: this.contentData.ai_text_tool_usage,
      ai_image_generator_used: this.contentData.ai_image_generator_used,
      ai_image_tool_usage: this.contentData.ai_image_tool_usage,
      ai_image_tool_usage_percentage:
        this.contentData.ai_image_tool_usage_percentage,
      ai_text_tool_usage_percentage:
        this.contentData.ai_text_tool_usage_percentage,
      creator: this.contentData.creator,
      creator_visible_on_game: this.contentData.creator_visible_on_game,
      creator_visible_on_map: this.contentData.creator_visible_on_map,
      created_at: this.contentData.created_at || this.contentData.date_created,
    });
    this.titleDynamicVal = this.contentData.content_title;
    this.contentDataImageArr = this.contentData.map_files;
    this.contentPotrait =
      this.contentData.image_url || this.contentData.cover_image;
    this.contentImgArr = this.contentDataImageArr;
    this.moduleRating = this.contentData?.module_rating || 0;
    this.userContentRating = this.contentData?.module_rating || 0;
    // this.userContentReview = this.contentData?.module_review || '';

    this.contentDataImageArr.map((item: MapFile) => {
      this.addMapImage(item);
    });

    this.contentData.adventure_writeup.map((item: ContentFile) => {
      const fileControl = this.formBuilder.control(item);
      this.mapFilesArray.push(fileControl);
    });

    this.patchValues({
      elevation: this.contentData.elevation,
      geozone: this.contentData.geozone,
      biome: this.contentData.biome,
      ruralLocation: this.contentData.ruralLocation,
      urbanLocation: this.contentData.urbanLocation,
      shops: this.contentData.shops,
    });
  }

  @HostListener('window:click', ['$event'])
  onClick(event: any) {
    if (
      this.mapElement &&
      this.mapElement.nativeElement.contains(event.target as HTMLElement)
    ) {
      this.mapService.handleMapContentClick(true, true, false, false);
    } else this.mapService.handleMapContentClick(false, true, false, false);
  }

  ngOnInit(): void {
    const activePath = localStorage.getItem('activePath');
    this.activePath = activePath.split('?')[0];

    // Check if returning from character creation
    this.activatedRoute.queryParams.subscribe((params) => {
      const newCharacterId = params['newCharacterId'];
      this.isOnlyRestore = params['isOnlyRestore'];
      if (params['type'] && !params['id']) {
        this.pendingCreateType = params['type'];
        this.applyPendingCreateType();
      }
      if (newCharacterId || this.isOnlyRestore) {
        // Restore form state from localStorage
        this.restoreFormState();

        if (newCharacterId) {
          // Select the newly created character
          setTimeout(() => {
            const currentCharacters =
              this.creatorDetailsForm.get('characters')?.value || [];
            if (!currentCharacters.includes(Number(newCharacterId))) {
              this.creatorDetailsForm.patchValue({
                characters: [...currentCharacters, Number(newCharacterId)],
              });
            }
          }, 1000); // Wait for both form and character list to be loaded
        }
      }
    
          this.cdr.detectChanges();
    });
  }

  private applyPendingCreateType(): void {
    if (!this.pendingCreateType || !this.creatorDetailsForm) return;
    this.creatorDetailsForm.patchValue({ type: this.pendingCreateType });
  }

  addMapImage(item: any) {
    const fileControl = this.formBuilder.control(item);

    this.mapImageFilesArray.push(fileControl);
  }

  generatePortrait(event) {
    event.stopPropagation();
    event.preventDefault();
    if (
      this.creatorDetailsForm.get('game_genre')?.value &&
      this.creatorDetailsForm.get('type')?.valid &&
      this.creatorDetailsForm.get('description')?.valid
    ) {
      const modalRef = this.modalService.open(AiGenerationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
      });

      let isFirst: string = 'first_upload';

      const payload = {
        game_genre: this.creatorDetailsForm.get('game_genre')?.value,
        content_type: this.creatorDetailsForm.get('type')?.value,
        description: this.creatorDetailsForm.get('description')?.value,
      };

      modalRef.componentInstance.playerDetails = payload;
      modalRef.componentInstance.userId = this.userId;
      modalRef.componentInstance.modalTitle = 'Content';
      modalRef.componentInstance.tokenCost = 4;
      modalRef.componentInstance.isFirst =
        this.contentData?.id || 'first_upload';

      modalRef.result
        .then((result) => {
          if (result?.content_image_base64) {
            this.contentPotrait = result.content_image_base64;
            this.creatorDetailsForm
              .get('cover_image')
              ?.setValue(result.content_image_base64);
            this.creatorDetailsForm.get('cover_image')?.markAsDirty();

            if (result.regular_image) {
              this.creatorDetailsForm.get('gameimage')?.setValue(result.regular_image);
            }

            const byteString = atob(result.content_image_base64.split(',')[1]);
            const mimeString = result.content_image_base64.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            this.gamePotraitFile = new File([blob], 'ai-generated-portrait.png', { type: mimeString });
          }
        
          this.cdr.detectChanges();})
        .catch(() => {});
    } else {
      this.toastService.showSuccess(
        'Please fill all the required fields (Game Genre, Content Type and Description)',
        'danger',
      );
    }
  }

  patchValues(backendData: {
    elevation: { [key: string]: boolean };
    geozone: { [key: string]: boolean };
    biome: { [key: string]: boolean };
    ruralLocation: { [key: string]: boolean };
    urbanLocation: { [key: string]: boolean };
    shops: { [key: string]: boolean };
  }): void {
    const config = [
      {
        key: 'elevation',
        array: this.elevationRangeRows,
        ranges: this.elevationRanges,
      },
      {
        key: 'geozone',
        array: this.geozoneRangeRows,
        ranges: this.geozoneRanges,
      },
      { key: 'biome', array: this.biomeRangeRows, ranges: this.biomeRanges },
      {
        key: 'urbanLocation',
        array: this.urbanLocationRows,
        ranges: this.urbanLocationRanges,
      },
      {
        key: 'ruralLocation',
        array: this.ruralLocationRows,
        ranges: this.ruralLocationRanges,
      },
      { key: 'shops', array: this.shopsRows, ranges: this.shopsRanges },
    ];

    config.forEach(({ key, array, ranges }) => {
      if (!array || array.length === 0) return;
      ranges.forEach((range, index) => {
        const isSelected = backendData[key]?.[range] || false;
        array
          .at(index)
          .patchValue({ selected: isSelected }, { emitEvent: false });
      });
      this.updateSelectAll(key);
    });
  }

  updateSelectAll(section: string): void {
    const rangesArray =
      section === 'elevation'
        ? this.elevationRangeRows
        : section === 'geozone'
          ? this.geozoneRangeRows
          : section === 'biome'
            ? this.biomeRangeRows
            : section === 'urbanLocation'
              ? this.urbanLocationRows
              : section === 'ruralLocation'
                ? this.ruralLocationRows
                : this.shopsRows;

    if (!rangesArray || rangesArray.length === 0) return;

    // Make sure all controls are initialized
    const allSelected = rangesArray.controls.every(
      (control) => control.get('selected')?.value === true,
    );

    // Prevent infinite loop with emitEvent: false
    const selectAllControl = this.creatorDetailsForm.get(
      `${section}.selectAll`,
    );
    if (selectAllControl?.value !== allSelected) {
      selectAllControl.setValue(allSelected, { emitEvent: false });
    }
  }

  /**
   * Lifecycle hook that is called after the component's view has been fully initialized.
   * This method sets the map target using the provided element reference and loads the map layers.
   * It also handles map content click events if the modal is not open. The map layers are loaded
   * based on the map code from the content data or a default value.
   */

  ngAfterViewInit(): void {
    this.activatedRoute.queryParamMap.subscribe((params) => {
      let isCityContent = false;
      this.contentId = params.get('id');
      this.params = params.get('mode');
      if (params.get('citycode')) {
        isCityContent = params.get('citycode') !== 'null';
      }
      this.mapCode = params.get('map_id') || params.get('mapcode');
      this.cityCode = params.get('citycode');

      this.backWordNavigateUrl = params.get('backwordNavigate');
      if (params.get('see_on_map_coordinates')) {
        this.see_on_map_coordinates = params.get('see_on_map_coordinates');
      }
      this.coords =
        params
          .get('coordinates')
          ?.split(',')
          .map((coord) => parseFloat(coord.trim())) || [];

      if (params.get('coordinates')) {
        this.rawCoordinates = params.get('coordinates');

        this.isModalOpen = true;
      }

      if (params.get('isEditable')) {
        this.isEditable = params.get('isEditable') === 'true';
      }
      const userJson = localStorage.getItem('currentUser');
      const userId = userJson && JSON.parse(userJson).id;

      if (this.params === 'edit') {
        this.dataService
          .getContentDetailsByUserId(userId, this.contentId)
          .subscribe((data: any) => {
            if (data) {
              this.contentData = data;
              this.initForm();
              if (!this.isEditable) {
                this.creatorDetailsForm.disable();
              }
              this.loadStoreState();

              this.coordsRecieve = this.contentData.location;
            }
          
          this.cdr.detectChanges();});
      } else {
        this.mapService.handlerAdded = false;
        this.initForm();
        if (this.rawCoordinates) {
          this.patchValuesOfRanges();
        }
        //  else if (this.params === 'edit' && isCityContent) {
        //   this.cityDataService
        //     .getContentCityById(this.contentId)
        //     .subscribe((data: any) => {
        //       if (data.res) {
        //         this.contentData = data.res;
        //         this.initForm();
        //         if (!this.isEditable) {
        //           this.creatorDetailsForm.disable();
        //         }
        //       }
        //     });
        // }
      }
      // this.coordinateService.pointDrawn$.subscribe((data) => {
      //   if (data) {
      //     this.coords = data;
      //   }
      // });
      this.dataService.getproductlist('gamemaster').subscribe((data: any) => {
        if (data) {
          const products = data.products;
          this.productlist = products.gamemaster;

          const order = [
            'One Shot Encounter',
            'Side Quest',
            'Mini Campaign / Adventure Arc',
            'Campaign',
            'Establishment',
          ];

          this.gameSystemListdata = this.productlist.filter(
            (item) => item.type === 'game_system',
          );
          this.gameTypeData = this.productlist
            .filter((item) => item.type === 'game_type')
            .sort(
              (a: any, b: any) =>
                (Number(a.sequence) || 0) - (Number(b.sequence) || 0),
            );
          const gameGenereList = this.productlist.filter(
            (item) => item.type === 'game_genre',
          );
          this.gameGenereList = processGenreGroups(gameGenereList);
          this.gameGenereList.sort((a: any, b: any) => {
            return (
              this.genreListSortOrder.indexOf(a.label) -
              this.genreListSortOrder.indexOf(b.label)
            );
          });
          this.productListLoaded.next(true);
          console.log(gameGenereList, this.gameGenereList);

          if (
            this.contentData &&
            this.contentData.gamesystem &&
            this.contentData.gamesystem.length > 0
          ) {
            // Find the category that contains the first selected genre
            const selectedGenre = this.contentData.gamesystem[0];
            const matchedCategory = findCategoryByGenre(
              selectedGenre,
              this.gameGenereList,
            );
            if (matchedCategory) {
              this.selectedGameGenreCategoryItems = matchedCategory.items;
              this.selectedGameGenreCategory = matchedCategory.label;
              this.creatorDetailsForm.patchValue({
                game_system: this.contentData.gamesystem,
              });
              this.cdr.detectChanges();
              this.creatorDetailsForm.patchValue(
                {
                  game_genre: this.selectedGameGenreCategory,
                },
                {
                  emitEvent: false,
                },
              );
            }
          }
        }
      });
      if (!this.isModalOpen) {
        // this.mapService.map.setTarget(
        //   this.elementRef.nativeElement.querySelector('#map')
        // );
        // this.mapCode = this.contentData?.mapcode;
        // this.mapService.loadlayers({
        //   map_id: this.mapCode ? this.mapCode : '000002',
        //   type: 'Master',
        // });
        // this.mapService.handleMapContentClick(
        //   false,
        //   false,
        //   false,
        //   this.coordsRecieve
        // );
      }
    });
  }

  onGameGenreChange(categoryLabel: string | null) {
    const { items, label } = getGenreItemsByCategory(
      categoryLabel,
      this.gameGenereList,
    );
    this.selectedGameGenreCategoryItems = items;
    this.selectedGameGenreCategory = label;
    // if (!this.params || this.params != 'edit') {
    this.creatorDetailsForm.get('game_system')?.setValue([]);
    // }
  }

  handleGameChangeImg(event) {
    const file = event.target.files[0];

    if (
      file &&
      (file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif')
    ) {
      const reader = new FileReader();
      this.isEdit = true;
      reader.onloadend = () => {
        // Set the base64-encoded image data to the form control

        this.selectedGameImage = reader.result;
        this.creatorDetailsForm
          .get('gameimage')
          .setValue(this.selectedGameImage);
        this.creatorDetailsForm.controls['gameimage'].setErrors(null);
        this.creatorDetailsForm.updateValueAndValidity();
        // Rebind the Croppie instance with the new image
      
          this.cdr.detectChanges();};
      reader.readAsDataURL(file);
    } else {
      this.toastService.showSuccess('Choose a PNG, JPG or WebP image.', 'danger');
    }
  }

  handleGameChangePotrait(event) {
    if (
      this.contentData &&
      this.contentData.access_type &&
      this.contentData.access_type.toLowerCase() !== 'creator'
    ) {
      this.toastService.showSuccess('Only the creator can edit this content.', 'danger');
      return;
    }
    const file = event.target.files[0];
    if (
      file &&
      (file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif')
    ) {
      const reader = new FileReader();
      // this.isEdit = true;
      reader.onloadend = () => {
        const modalRef = this.modalService.open(ContentImageUploadModalComponent, { size: 'lg', backdrop: 'static', centered: true });
        modalRef.componentInstance.selectedImage = reader.result as string;
        modalRef.componentInstance.aiGenerateModal = false;

        modalRef.result.then((result) => {
          if (result?.content_image_base64) {
            this.contentPotrait = result.content_image_base64;
            this.creatorDetailsForm.get('cover_image').setValue(this.contentPotrait);
            this.creatorDetailsForm.controls['cover_image'].setErrors(null);
            

            this.creatorDetailsForm.updateValueAndValidity();
            this.creatorDetailsForm.markAsDirty();

            // Set gamePotraitFile to be sent to backend
            const byteString = atob(this.contentPotrait.split(',')[1]);
            const mimeString = this.contentPotrait.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            this.gamePotraitFile = new File([blob], file.name, { type: mimeString });
          }
        
          this.cdr.detectChanges();}).catch(() => {});
      
          this.cdr.detectChanges();};
      reader.readAsDataURL(file);
    } else {
      this.toastService.showSuccess('Choose a PNG, JPG or WebP image.', 'danger');
    }
  }

  handleCreatorImages(event) {
    const file = event.target.files[0];
    if (
      file &&
      (file.type === 'image/png' ||
        file.type === 'image/jpeg' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif')
    ) {
      const reader = new FileReader();
      this.isCreatorImageTouched = true;
      reader.onloadend = () => {
        // Set the base64-encoded image data to the form control
        this.contentImgArr.push(reader.result);
        this.creatorDetailsForm
          .get('contentimagearr')
          .setValue(this.contentImgArr);
        // if (this.contentImgArr.length == 2) { this.uploadContainerHeight = this.contentImgArr.length * 300 + 'px' }
        // else if (this.contentImgArr.length == 4) { this.uploadContainerHeight = this.contentImgArr.length * 100 + 'px' }
        // else { this.uploadContainerHeight = this.uploadContainerHeight }
        if (!this.contentData)
          this.creatorDetailsForm.controls['contentimagearr'].setErrors(null);
        this.creatorDetailsForm.updateValueAndValidity();
        // Rebind the Croppie instance with the new image
      
          this.cdr.detectChanges();};
      reader.readAsDataURL(file);
    } else {
      this.toastService.showSuccess('Choose a PNG, JPG or WebP image.', 'danger');
    }
  }

  getAllContentRecords(call, isCity) {
    if (!isCity) {
      this.dataService
        .getContentDataByUserId(this.userId)
        .subscribe((data: any) => {
          if (data) {
            this.allContentData = data;
            if (call) {
              this.closeModal(this.allContentData);
            }
          }
        
          this.cdr.detectChanges();});
    } else {
      this.cityDataService
        .getContentCityByUserId(this.userId)
        .subscribe((data: any) => {
          if (data) {
            this.allContentData = data;
            this.closeModal(data);
          }
        
          this.cdr.detectChanges();});
    }
  }

  private constructPayload(checkBoxObj: ContentCheckBoxObject): any {
    const mainObject = {
      ...this.creatorDetailsForm.getRawValue(),
      map_link: this.backWordNavigateUrl || this.contentData?.map_link || '',
      user_id: this.userId,
      geozone: checkBoxObj.geozoneObject,
      urbanLocation: checkBoxObj.urbanLocationObject,
      ruralLocation: checkBoxObj.ruralLocationObject,
      shops: checkBoxObj.shopsObject,
      elevation: checkBoxObj.elevationObject,
      biome: checkBoxObj.biomeObject,
    };

    if (mainObject.ai_text_generator_used === false) {
      mainObject.ai_text_tool_usage = '';
      mainObject.ai_text_tool_usage_percentage = 0;
    }

    if (mainObject.ai_image_generator_used === false) {
      mainObject.ai_image_tool_usage = '';
      mainObject.ai_image_tool_usage_percentage = 0;
    }

    const contentDataObject = this.omit(mainObject, [
      'adventure_writeup',
      'map_files',
      'cover_image',
    ]);
    const formData = new FormData();

    const contentImageArray = this.mapFilesArray.value;
    formData.append('content_data', JSON.stringify(contentDataObject));
    this.mapImageFilesArray.value.map((file: File) => {
      if (file instanceof File) {
        formData.append('map_files', file);
      }
    });
    this.mapFilesArray.value.map((file: File) => {
      if (file instanceof File) {
        formData.append('adventure_writeup', file);
      }
    });
    if (this.gamePotraitFile) {
      formData.append('cover_image', this.gamePotraitFile);
    }
    return formData;
  }

  omit(obj, keysToRemove) {
    return Object.keys(obj).reduce((acc, key) => {
      if (!keysToRemove.includes(key)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  }

  private afterSuccessfulSubmission(isCity: boolean = false): void {
    this.creatorDetailsForm.markAsPristine();
    this.creatorDetailsForm.markAsUntouched();
    this.creatorDetailsForm.updateValueAndValidity();

    if (this.isModalOpen) {
      if (this.backWordNavigateUrl) {
        const { path, queryParams } = this.constructUrl(
          this.backWordNavigateUrl,
        );
        this.router.navigate([path], { queryParams });
      } else {
        this.router.navigate(['/content-creator']);
      }

      this.getAllContentRecords(true, isCity);
      this.errorMessage = '';
      return;
    }

    this.router.navigate(['/content-creator']);
  }

  constructUrl(url, isRedirect?: boolean) {
    const decodedUrl = decodeURIComponent(url);
    const [path, queryString] = decodedUrl.split('?');

    const existingParams: { [key: string]: string } = {};
    if (queryString) {
      const params = new URLSearchParams(queryString);
      params.forEach((value, key) => {
        existingParams[key] = value;
      });
    }
    console.log('while coming here ');

    const queryParams = {
      ...existingParams,
      refresh: Date.now(),
      redirect_coords:
        isRedirect && Array.isArray(this.contentData?.location)
          ? this.contentData.location.join(',')
          : null,
    };
    return { path, queryParams };
  }

  private handleFormError(error: any): Observable<boolean> {
    if (error?.error?.error) {
      const keys = Object.keys(error.error.error);
      this.toastService.showSuccess(
        `This field may not be blank: ${keys.join(',')}`,
        'danger',
      );
    } else {
      this.toastService.showSuccess('Something went wrong. Please try again.', 'danger');
    }
    return of(false);
  }

  getInvalidControls(): string[] {
    const invalidControls: string[] = [];
    for (const controlName in this.creatorDetailsForm.controls) {
      const control = this.creatorDetailsForm.controls[controlName];
      if (control.invalid) {
        invalidControls.push(controlName);
      }
    }
    return invalidControls;
  }

  commonLogicOnlineDelete(imageId) {
    this.contentDataImageArr.findIndex((item, index) => {
      if (item?.id == imageId) {
        this.contentDataImageArr.splice(index, 1);
      }
    });
    this.toastService.showSuccess('Picture deleted.', 'success');
  }
  removeImage(imageId, isId?: boolean) {
    if (isId) {
      if (!this.cityCode) {
        this.dataService
          .deleteImageFromContent(imageId)
          .subscribe((data: any) => {
            if (data) {
              this.commonLogicOnlineDelete(imageId);
            }
          
          this.cdr.detectChanges();});
      } else {
        this.cityDataService
          .deleteContentCreaterImage(imageId)
          .subscribe((data: any) => {
            if (data) {
              this.commonLogicOnlineDelete(imageId);
            }
          
          this.cdr.detectChanges();});
        this.contentImgArr = this.contentDataImageArr;
      }
    } else {
      this.contentImgArr.splice(imageId, 1);
    }
  }

  closeModal(data) {
    this.activeModal.close(data);
  }

  constructCheckBoxObject(): ContentCheckBoxObject {
    const elevationObject = this.elevationRanges.reduce(
      (obj, range, index) => {
        obj[range] =
          this.elevationRangeRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    const geozoneObject = this.geozoneRanges.reduce(
      (obj, range, index) => {
        obj[range] =
          this.geozoneRangeRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    const biomeObject = this.biomeRanges.reduce(
      (obj, range, index) => {
        obj[range] =
          this.biomeRangeRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    const ruralLocationObject = this.ruralLocationRanges.reduce(
      (obj, range, index) => {
        obj[range] =
          this.ruralLocationRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    const urbanLocationObject = this.urbanLocationRanges.reduce(
      (obj, range, index) => {
        obj[range] =
          this.urbanLocationRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    const shopsObject = this.shopsRanges.reduce(
      (obj, range, index) => {
        obj[range] = this.shopsRows.at(index).get('selected')?.value || false;
        return obj;
      },
      {} as { [key: string]: boolean },
    );

    return {
      elevationObject,
      geozoneObject,
      biomeObject,
      urbanLocationObject,
      ruralLocationObject,
      shopsObject,
    };
  }

  resolveImageSrc(cover_image: string): string {
    if (cover_image.startsWith('data:image/')) {
      return cover_image; // base64 image
    } else {
      return cover_image; // URL scenario
    }
  }

  /**
   * Removes a file input (FormControl) from the FormArray at a specific index.
   * This function controls the dynamic removal of file inputs from the UI.
   * @param index The index of the file input to remove.
   */
  removeFileInput(index: number, control: AbstractControl | FormControl): void {
    if (
      this.mapImageFilesArray.length > this.minFilesRequired ||
      control.errors?.['invalidFileType']
    ) {
      // Prevent removing if it violates min
      this.mapImageFilesArray.removeAt(index);
      // After removing, force validation check on the FormArray to update min/max errors
      this.mapImageFilesArray.updateValueAndValidity();
    } else {
      window.alert(
        `You must upload at least ${this.minFilesRequired} file(s).`,
      );
      console.warn(
        `Cannot remove file. At least ${this.minFilesRequired} file(s) are required.`,
      );
    }
  }

  /**
   * Handles the 'change' event from an individual file input.
   * This is where the selected File object gets associated with its FormControl.
   * @param event The DOM event from the file input.
   * @param index The index of the FormControl in the FormArray to update.
   */
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const newFiles: FileList | null = input.files;

    if (newFiles) {
      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];

        // Check if adding this file would exceed the max file count
        if (this.mapImageFilesArray.length >= this.maxFilesLimit) {
          console.warn(
            `Max file limit (${this.maxFilesLimit}) reached. Cannot add more files.`,
          );
          window.alert(
            `You can upload a maximum of ${this.maxFilesLimit} files.`,
          );
          break;
        }

        // Create a new FormControl for each selected file with individual file validators
        const fileControl = this.formBuilder.control(file, [
          Validators.required,
          CustomFileUploadValidators.fileProperties(
            this.allowedMimeTypesForMapFiles,
            this.maxTotalFileSize,
          ),
        ]);
        this.mapImageFilesArray.push(fileControl);
        this.creatorDetailsForm.markAsDirty();
      }

      // Crucially, update the validity of the FormArray itself to re-run
      // minFiles, maxFiles, and totalFileSize validators.
      this.mapImageFilesArray.updateValueAndValidity();
      this.creatorDetailsForm.get('files')?.updateValueAndValidity();
    }
  }

  onFileSelectedMapFiles(event: Event): void {
    const input = event.target as HTMLInputElement;
    const newFiles: FileList | null = input.files;

    if (newFiles) {
      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];

        // Check if adding this file would exceed the max file count
        if (this.mapFilesArray.length >= this.maxFilesLimit) {
          console.warn(
            `Max file limit (${this.maxFilesLimit}) reached. Cannot add more files.`,
          );
          window.alert(
            `You can upload a maximum of ${this.maxFilesLimit} files.`,
          );
          break;
        }

        // Create a new FormControl for each selected file with individual file validators
        const fileControl = this.formBuilder.control(file, [
          Validators.required,
          CustomFileUploadValidators.fileProperties(
            this.allowedMimeTypes,
            this.maxTotalFileSize,
          ),
        ]);

        this.mapFilesArray.push(fileControl);
        this.creatorDetailsForm.markAsDirty();
      }
      // Crucially, update the validity of the FormArray itself to re-run
      // minFiles, maxFiles, and totalFileSize validators.
      this.mapFilesArray.updateValueAndValidity();
    }
  }

  removeMapFileInput(
    index: number,
    control: AbstractControl | FormControl,
  ): void {
    if (
      this.mapFilesArray.length > this.minFilesRequired ||
      control.errors?.['invalidFileType']
    ) {
      // Prevent removing if it violates min
      this.mapFilesArray.removeAt(index);
      // After removing, force validation check on the FormArray to update min/max errors
      this.mapFilesArray.updateValueAndValidity();
    } else {
      window.alert(
        `You must upload at least ${this.minFilesRequired} file(s).`,
      );
      console.warn(
        `Cannot remove file. At least ${this.minFilesRequired} file(s) are required.`,
      );
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  onSave(): void {
    if (this.isSaving) return;

    const modalRef = this.modalService.open(SavingLoaderModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });

    this.isSaving = true;
    this.handleFormSubmit().subscribe({
      next: (success) => {
        this.isSaving = false;
        modalRef.close();
        if (success) {
          // Navigation and toast are already handled in submitObservable
        } else {
        }
      
          this.cdr.detectChanges();},
      error: (error) => {
        this.isSaving = false;
        modalRef.close();
        console.error('Error during save', error);
      
          this.cdr.detectChanges();},
    });
  }

  onDownload(): void {
    // const modalRef = this.modalService.open(DownloadLoaderModalComponent, {
    //   centered: true,
    //   backdrop: 'static',
    //   keyboard: false,
    // });

    // if (!this.cityCode || this.cityCode == 'null') {
    //   this.dataService.downloadContentFiles(this.contentData.id).subscribe({
    //     next: (response: any) => {
    //       modalRef.close();
    //       const blob = new Blob([response], { type: 'application/zip' });
    //       const url = window.URL.createObjectURL(blob);
    //       const a = document.createElement('a');
    //       a.href = url;
    //       a.download = `${this.contentData.content_title}.zip`;
    //       document.body.appendChild(a);
    //       a.click();
    //       document.body.removeChild(a);
    //       window.URL.revokeObjectURL(url);
    //     },
    //     error: (error) => {
    //       modalRef.close();
    //       this.toastService.showSuccess("We couldn't download the files. Please try again.", 'danger');
    //     },
    //   });
    // } else {
    //   this.cityDataService
    //     .downloadCityContentFiles(this.contentData.id)
    //     .subscribe({
    //       next: (response: any) => {
    //         modalRef.close();
    //         const blob = new Blob([response], { type: 'application/zip' });
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `${this.contentData.content_title}.zip`;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url);
    //       },
    //       error: (error) => {
    //         this.toastService.showSuccess('Error downloading city content files', 'danger');
    //         modalRef.close();
    //       },
    //     });
    // }

    // old code

    // new code

    // The creator downloads their own files as a zip.
    if (!this.contentData?.id || this.downloading) return;
    this.downloading = true;
    const isCity = this.cityCode && this.cityCode != 'null';
    const download$ = isCity
      ? this.cityDataService.downloadCityContentFiles(this.contentData.id)
      : this.dataService.downloadContentFiles(this.contentData.id);
    download$.subscribe({
      next: (response: any) => {
        const blob = new Blob([response], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.contentData.content_title}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.downloading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.downloading = false;
        this.toastService.showSuccess("We couldn't download the files. Please try again.", 'danger');
        this.cdr.detectChanges();
      },
    });
  }

  onBack(): void {
    // Back to where the page was opened from (the map or city you
    // right-clicked on); otherwise the Content Vault. It used to depend on
    // whether a map spot was passed, and could get stuck on "Loading...".
    if (this.backWordNavigateUrl) {
      const { path, queryParams } = this.constructUrl(this.backWordNavigateUrl);
      this.router.navigate([path], { queryParams });
    } else {
      this.router.navigate(['/content-creator']);
    }
  }

  report() {
    const modalRef = this.modalService.open(ReportingModalComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.moduleName = this.contentData.content_title;
    modalRef.componentInstance.contentCreator = this.contentData.creator;
    modalRef.componentInstance.userId = this.userId;
    modalRef.componentInstance.contentId = this.contentData.id;
    modalRef.componentInstance.contentType = this.contentData.citycode
      ? 'city'
      : 'content';
    modalRef.result.then((result) => {
      if (result.action === 'submitted') {
      }
    
          this.cdr.detectChanges();});
  }

  /**
   * Handles character dropdown change event
   * Detects when "Create New" option is selected and triggers navigation
   */
  onCharacterChange(event: any): void {
    const selectedValue = event;

    // Since ng-select is multiple, selectedValue is an array
    // It could be an array of IDs (strings/numbers) or array of objects
    let hasCreateNew = false;

    if (Array.isArray(selectedValue)) {
      // Check if any item is 'CREATE_NEW' (if array of IDs)
      // or has id === 'CREATE_NEW' (if array of objects)
      hasCreateNew = selectedValue.some((item: any) => {
        if (typeof item === 'object' && item !== null) {
          return item.id === 'CREATE_NEW';
        }
        return item === 'CREATE_NEW';
      });
    }

    if (hasCreateNew) {
      // Remove the CREATE_NEW value from selection
      const characters = this.creatorDetailsForm.get('characters')?.value || [];
      const filteredCharacters = characters.filter((c: any) => {
        if (typeof c === 'object' && c !== null) {
          return c.id !== 'CREATE_NEW';
        }
        return c !== 'CREATE_NEW';
      });
      this.creatorDetailsForm.patchValue(
        { characters: filteredCharacters },
        { emitEvent: false },
      );

      // Navigate to character creation
      this.navigateToCharacterCreation();
    }
  }

  /**
   * Navigates to character creation page while preserving current form state
   */
  navigateToCharacterCreation(): void {
    // Save current form state to localStorage
    this.saveFormState();

    // Mark form as pristine to bypass the guard (we've already saved the state)
    this.creatorDetailsForm.markAsPristine();

    // Navigate to character creation with query params
    this.router.navigate(['/player-detail', 'create'], {
      queryParams: {
        mode: 'create',
        returnToContentCreation: 'true',
        coordinates: this.rawCoordinates,
        backUrl: this.backWordNavigateUrl,
        contentCityCode: this.cityCode,
        contentMapCode: this.mapCode,
      },
    });
    // this.creatorDetailsForm.markAsDirty();
  }

  /**
   * Saves current form state to localStorage
   */
  private saveFormState(): void {
    const formState = {
      formValue: this.creatorDetailsForm.getRawValue(),
      timestamp: new Date().getTime(),
    };

    localStorage.setItem('contentCreationFormState', JSON.stringify(formState));
  }

  /**
   * Restores form state from localStorage
   */
  private restoreFormState(): void {
    const savedState = localStorage.getItem('contentCreationFormState');

    if (savedState) {
      try {
        const formState = JSON.parse(savedState);

        // Check if state is not too old (e.g., max 1 hour)
        const maxAge = 60 * 60 * 1000; // 1 hour in milliseconds
        if (new Date().getTime() - formState.timestamp < maxAge) {
          // Wait for form to be initialized before restoring
          setTimeout(() => {
            if (this.creatorDetailsForm) {
              // Restore form values
              this.creatorDetailsForm.patchValue(formState.formValue);
              this.creatorDetailsForm.get('cover_image').setValue(null);

              // Mark form as dirty to indicate changes
              this.creatorDetailsForm.markAsDirty();
            }
          }, 100);
        }

        // Clean up localStorage
        localStorage.removeItem('contentCreationFormState');
      } catch (error) {
        console.error('Error restoring form state:', error);
        localStorage.removeItem('contentCreationFormState');
      }
    }
  }

  patchValuesOfRanges() {
    combineLatest([
      this.mapDataService.contentRangesPatch$,
      this.productListLoaded.asObservable(),
      this.formReady$.asObservable(),
    ]).subscribe({
      next: ([data, isLoaded, isFormReady]) => {
        if (data && isLoaded && isFormReady) {
          this.patchValues(data);

          if (data.game_genre) {
            const matchedCategory = this.gameGenereList.find(
              (category) => category.label === data.game_genre,
            );
            if (matchedCategory) {
              this.selectedGameGenreCategoryItems = matchedCategory.items;
              this.selectedGameGenreCategory = matchedCategory.label;
              debugger;
              this.creatorDetailsForm.patchValue(
                {
                  game_genre: matchedCategory.label,
                },
                { emitEvent: false },
              );
            }
          }

          if (data.game_system) {
            this.creatorDetailsForm.patchValue(
              {
                game_system: [data.game_system],
              },
              { emitEvent: false },
            );
          }
        }
      
          this.cdr.detectChanges();},
    });
  }

  seeOnMap() {
    const { path, queryParams } = this.constructUrl(
      this.contentData?.map_link,
      true,
    );
    this.router.navigate([path], { queryParams });
  }

  constructUrlAndNavigate(pin_instance: Pin) {
    if (
      pin_instance.map_id &&
      (!pin_instance.city_id || pin_instance.city_id == '')
    ) {
      sessionStorage.setItem(
        'contentCreationLat',
        this.see_on_map_coordinates.split(',')?.[1] || '0',
      );
      sessionStorage.setItem(
        'contentCreationLon',
        this.see_on_map_coordinates.split(',')?.[0] || '0',
      );
      sessionStorage.setItem('contentCreationZoom', '15');
      this.router.navigate(['/map/' + pin_instance.map_id]);
    } else if (pin_instance.city_id) {
      console.log('while coming here ');
      this.router.navigate(
        [
          'city-map-view',
          pin_instance.city_id,
          pin_instance.map_id,
          'null',
          'null',
        ],
        {
          queryParams: {
            token: '',
            isLoadToken: false,
            isCityVisited: true,
            game_system: null,
            backRoute: 'map',
            redirect_coords:
              pin_instance.longitude + ',' + pin_instance.latitude,
          },
        },
      );
    }
  }

  openInStore(content: ContentData) {
    if (!this.storeLinks.openContent(content)) {
      this.toastService.showSuccess('This item is not in the store yet.', 'danger');
    }
  }

}

// this.router.navigate(
//   [
//     'city-map-view',
//     feature.getProperties()['burg_id'],
//     this.mapCodeDataContainer.map_id,
//     this.mapCodeDataContainer.game_id ?? 'null',
//     this.mapCodeDataContainer.character_id ?? 'null',
//   ],
//   {
//     queryParams: {
//       token: this.userProfileUrl,
//       isLoadToken: false,
//       isCityVisited: true,
//       game_system: this.game_system || null,
//       backRoute,
//     },
//   },
